<template>
    <div class="popup" @mousedown.self="$emit('close')">
        <div class="popup__block">
            <div class="popup__top">
                <div class="popup__title">Предложения поставщика «{{ selectedSupplierOffers.name }}»</div>
                <div class="popup__close" @click="$emit('close')"></div>
            </div>
            <div class="popup__content">
                <main-filter :grey-theme="true">
                    <div class="filters__item filters__item--3">
                        <div class="filters__item--double">
                            <InputText :label="'Поиск по товару'" :placeholder="'Введите название товара'" v-model="filter.productName"/>
                            <InputText :label="'Поиск по тендеру'" :placeholder="'Введите название тендера'" v-model="filter.tenderName"/>
                        </div>
                    </div>

                    <div class="filters__item filters__item--2">
                        <div class="filters__btns">
                            <button type="submint" class="btn btn--color" @click="updateSupplierOffers">Применить</button>
                            <button class="btn btn--trans" @click="clearFilter();">Сбросить фильтр</button>
                        </div>
                    </div>
                </main-filter>
                <hr>
                <table class="table-inner">
                    <thead class="table-inner__head">
                        <tr class="table-inner__row">
                            <td class="table-inner__col">№ тендера</td>
                            <td class="table-inner__col">№ позиции</td>
                            <td class="table-inner__col">Название тендера</td>
                            <td class="table-inner__col">Название товара</td>
                            <td class="table-inner__col">Валюта</td>
                            <td class="table-inner__col">НДС</td>
                            <td class="table-inner__col">Цена</td>
                        </tr>
                    </thead>
                    <tbody class="table-inner__body">
                        <tr class="table-inner__row" v-for="offer in supplierOffers.items" :key="offer.id">
                            <td class="table-inner__col">
                                <span class="table-inner__col-label">№ тендера</span>
                                <span class="table-inner__col-cont">{{ offer.tenderId }}</span>
                            </td>
                            <td class="table-inner__col">
                                <span class="table-inner__col-label">№ позиции</span>
                                <span class="table-inner__col-cont">{{ offer.positionId }}</span>
                            </td>
                            <td class="table-inner__col">
                                <span class="table-inner__col-label">Название тендера</span>
                                <span class="table-inner__col-cont">
                                    <a :href="`/personal/tenders/?ID=${offer.tenderId}`" target="_blank" class="table__col-cont table__col-cont--green">
                                        <b>{{ offer.tenderName }}</b>
                                    </a>
                                </span>
                            </td>
                            <td class="table-inner__col">
                                <span class="table-inner__col-label">Название товара</span>
                                <span class="table-inner__col-cont">{{ offer.productName }}</span>
                            </td>
                            <td class="table-inner__col">
                                <span class="table-inner__col-label">Валюта</span>
                                <span class="table-inner__col-cont">{{ offer.currencyName }}</span>
                            </td>    
                            <td class="table-inner__col">
                                <span class="table-inner__col-label">НДС</span>
                                <span class="table-inner__col-cont">{{ offer.vatName }}</span>
                            </td>
                            <td class="table-inner__col">
                                <span class="table-inner__col-label">Цена</span>
                                <span class="table-inner__col-cont"><b>{{ offer?.price?.toLocaleString('RU-ru') }}&nbsp;₽ </b></span>
                            </td>
                          
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination">
                <vue-awesome-paginate
                    v-if="supplierOffers?.countTotal > filter.limit"
                    :total-items="+supplierOffers?.countTotal"
                    :items-per-page="filter.limit"
                    :max-pages-shown="3"
                    v-model="currentPage"
                    :on-click="changePage" />
            </div>
            <hr>
            <div class="popup__btns">
                <a :href="downloadUrl" class="btn btn--color">Выгрузить статистику</a>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import MainFilter from "@/components/blocks/MainFilter.vue";
import InputText from "@/components/base/utils/formElements/InputText.vue";


export default {
    name: 'StatsOffersPopup',
    props: {
        selectedSupplierOffers: {
            type: Object,
            default: () => {}
        },
    },
    components: {
        MainFilter, InputText
    },
    data() {
        return {
            filter: {
                productName: '',
                tenderName: '',
                total: 0,
                offset: 0,
                limit: 10,
            },
            currentPage: 1,
        }
    },
    created() {
        this.requestSupplierOffers({id: this.selectedSupplierOffers.id, search: this.filter})
    },
    methods: {
		async changePage(value) {
			this.filter.offset =  (value - 1) * this.filter.limit || 0
			await this.requestSupplierOffers({id: this.selectedSupplierOffers.id, search: this.filter})
		},
		async clearFilter() {
			this.filter.productName = ''
            this.filter.tenderName = ''

			await this.requestSupplierOffers({id: this.selectedSupplierOffers.id, search: this.filter})
		},

		async updateSupplierOffers(value) {
			this.filter.offset = (value - 1) * this.filter.limit || 0
			await this.requestSupplierOffers({id: this.selectedSupplierOffers.id, search: this.filter})
		},
        ...mapActions({
			requestSupplierOffers: 'stats/requestSupplierOffers',
		}),
    },
    computed: {
        downloadUrl() {
            return `${window?.location?.origin}/api/tenders/stats/supplier-offers/${this.selectedSupplierOffers.id}/export/excel/`
        },
        ...mapGetters({
            supplierOffers: 'stats/getSupplierOffers',
        }),
    },
}
</script>
